import { render, staticRenderFns } from "./filesList.vue?vue&type=template&id=2e2205d8&scoped=true&"
import script from "./filesList.vue?vue&type=script&lang=js&"
export * from "./filesList.vue?vue&type=script&lang=js&"
import style0 from "./filesList.vue?vue&type=style&index=0&id=2e2205d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2205d8",
  null
  
)

export default component.exports